<template>
  <div class="d-flex flex-column min-vh-100">
    <header class="simple-hero text-center py-5 px-3 px-lg-0">
      <div class="container hero-inner">
        <div class="logo-pill">
          <img
            src="/assets/img/logo-dark.png"
            alt="logo-img"
            class="hero-logo"
          />
        </div>
        <h1>كوّن <span class="hero-highlight">باقتك</span> الخاصة بسهولة</h1>
        <p>اختر الدورات وأرسلها لأصدقائك لتستفيد من التخفيضات الفورية.</p>
        
      </div>
    </header>

    <!-- Main Content -->
    <main class="flex-fill py-4">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <router-view />
          </div>
        </div>
      </div>
    </main>

    <!-- Footer -->
    <footer class="bg-dark text-white py-3">
      <div class="container text-center">
        <p> جميع الحقوق محفوظة <a style="color:#00c444" href="https://student.academia.ly">منصة
            أكاديميا</a> &copy; <span id="currentYear"></span> </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "MainLayout",
};
</script>

<style scoped>
.simple-hero {
  background: #fff;
  color: #0f172a;
  border-bottom-left-radius: 32px;
  border-bottom-right-radius: 32px;
  box-shadow: 0 15px 35px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(0, 196, 68, 0.08);
}

.hero-inner {
  max-width: 720px;
}

.logo-pill {
 
  padding: 0.75rem 1.25rem;
  
  margin-bottom: 1.25rem;
}

.hero-logo {
  width: 160px;
}

.simple-hero h1 {
  font-weight: 800;
  margin-bottom: 2rem;
  font-size: clamp(1.6rem, 4vw, 2.7rem);
}

.simple-hero p {
  opacity: 0.8;
  margin-bottom: 1.25rem;
  font-size: 1rem;
}

.hero-highlight {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 0 0.35rem;
  border-radius: 12px;
  background: rgba(0, 196, 68, 0.12);
  color: #00a957;
  font-weight: 900;
}

.hero-highlight::after {
  content: "";
  position: absolute;
  left: 8%;
  right: 8%;
  bottom: -6px;
  height: 4px;
  background: linear-gradient(90deg, #00c444, #00e08a);
  border-radius: 999px;
}

.hero-tags {
  display: inline-flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.hero-tags span {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  padding: 0.4rem 0.9rem;
  font-size: 0.9rem;
  font-weight: 600;
}

@media (max-width: 575px) {
  .hero-logo {
    width: 130px;
  }
}
</style>
